<template>
    <div :class="[display, !left ? 'flex-row-reverse' : '']">
        <tooltip
            key="extras"
            :content="`${users.length - max} more`"
            class="-mr-8"
            :class="sizeClass"
            position="bottom"
            v-if="max && users.length > max"
        >
            <avatar
                border
                class="cursor-default"
                :color="styles.colors.primary['60']"
                :size="size"
            >
                +{{ users.length - max }}
            </avatar>
        </tooltip>

        <template v-for="(user, i) in users">
            <tooltip
                v-if="!max || i < max"
                position="bottom"
                class="-mr-8 z-10 hover:z-50"
                :class="sizeClass"
                :content="user.name"
                :key="user.id"
            >
                <avatar
                    border
                    :image="user.image_url"
                    :size="size"
                    class="cursor-default"
                >{{ user.initials }}</avatar>
            </tooltip>
        </template>
    </div>
</template>

<script>
import styles from "../../../../../../styles.config";
import Avatar from "./Avatar";
import Tooltip from "../navigation/Tooltip";

export default {
    components: {Tooltip, Avatar},
    props: {
        users: Array,
        max: Number,
        display: {
            type: String,
            default: 'flex'
        },
        size: {
            type: String,
            default: 'medium',
            validator: value => ['small', 'medium', 'large'].includes(value),
        },
        left: Boolean
    },
    data() {
        return {
            sizes: {
                small: 'w-36 h-36',
                medium: 'w-52 h-52',
                large: 'w-100 h-100',
            },
        }
    },
    computed: {
        styles() {
            return styles;
        },
        sizeClass() {
            return this.sizes[this.size];
        },
    }
}
</script>
